const modulesData = [
	{
		id: 's1-m1',
		background: 'school',
		title: {
			da: 'Første halvdel',
		},
		minStars: 3,
		requiredModuleIds: [],
		tasks: require('./modules/module-1').moduleTasks,
		gameOverWin: {
			da: `Du har bestået med maksimal score. Du udviste fremragende dømmekraft og pædagogiske evner gennem første del af dagen.
				<br /><br /> Du mestrede både: <ul><li>Klasseledelse og konflikthåndtering</li><li>Faglig formidling og differentiering</li><li>Relationskompetence og professionel autoritet</li></ul>`,
			en: ``
		},
		gameOverLose: {
			da: `God indsats! 
				<br /><br /> Du har klaret mange situationer godt, men der er plads til forbedring. Prøv igen og se om du kan håndtere nogle af situationerne anderledes. Du skal have 3 stjerner for at bestå spillet.`,
			en: ``
		}
	},
	{
		id: 's1-m2',
		background: 'school',
		title: {
			da: 'Anden halvdel'
		},
		minStars: 3,
		requiredModuleIds: ['s1-m1'],
		tasks: require('./modules/module-2').moduleTasks,
		gameOverWin: {
			da: `Du har bestået med maksimal score. Du udviste fremragende dømmekraft og pædagogiske evner gennem den sidste del af dagen.
				<br /><br /> Du mestrede både: <ul><li>Klasseledelse og konflikthåndtering</li><li>Faglig formidling og differentiering</li><li>Relationskompetence og professionel autoritet</li></ul>`,
			en: ``
		},
		gameOverLose: {
			da: `God indsats! 
				<br /><br /> Du har klaret mange situationer godt, men der er plads til forbedring. Prøv igen og se om du kan håndtere nogle af situationerne anderledes. Du skal have 3 stjerner for at bestå spillet.`,
			en: ``
		}
	}
]

export {
	modulesData
};